// @ts-nocheck
import { statusStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus";
import { orderDataLabel } from "@store/Themes/common/props/checkout";
import { css } from "styled-components";

Object.assign(statusStyles, {
    wrapper: {
        css: css`
            padding-bottom: 0;
        `,
    },
    titleText: orderDataLabel,
});
